var gMap = function(i){
	var map, center, mk;
	var lng 	= $(".map:eq(" + i + ")").attr("data-lng");
	var lat 	= $(".map:eq(" + i + ")").attr("data-lat");
	var c = "";
	initialize();
	function initialize() {//初期化
		var image = {
			url : '/images/about/icon_pin.png',
			scaledSize : new google.maps.Size(260, 58)
		}
		var zoom = 17;
		var options = {
			center: new google.maps.LatLng(lat,lng),
			zoom: zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			disableDefaultUI: false,
			streetViewControl: false,
			scaleControl: true,
			panControl: true,
			zoomControl: true,
			overviewMapControl: true,
			mapTypeControl: false,
			panControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			mapTypeControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER
			},
			styles: c
			};
		map = new google.maps.Map($(".map:eq(" + i + ")").get(0), options);
		var image = "/images/common/_pointer.png"
		new google.maps.Marker({
			//icon : image,
			map: map,
			position: new google.maps.LatLng(lat,lng)
		});
		google.maps.event.addDomListener(window, "resize", function() {
			var center = map.getCenter();
			google.maps.event.trigger(map, "resize");
			map.panTo(center); 
		});
	}
}